import moment from "moment"

export const formattedEventDates = (
  start: Date | null | undefined,
  end: Date | null | undefined,
  formatType?: string,
) => {
  if (!start || !end) return "∞"
  if (start && !end) return `from ${moment(start).format(formatType)}`
  if (!start && end) return `until ${moment(end).format(formatType)}`
  return `${moment(start).format(formatType)} - ${moment(end).format(formatType)}`
}
